import React from "react";
import { Box, Typography, alpha, useTheme } from "@mui/material";
import { getStatusMeta } from "../utils/utils";

/**
 * Единственный вид статуса во всём интерфейсе: точка в насыщенном цвете плюс
 * подпись в тоне, читаемом на текущей поверхности. Цвет не единственный
 * носитель смысла — подпись всегда рядом.
 */
const StatusPill: React.FC<{ status?: string | null; dense?: boolean }> = ({
  status,
  dense,
}) => {
  const theme = useTheme();
  const meta = getStatusMeta(status, theme.palette.mode);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: dense ? 0.85 : 1,
        py: dense ? 0.3 : 0.4,
        borderRadius: "8px",
        whiteSpace: "nowrap",
        backgroundColor: alpha(meta.color, 0.14),
        border: `1px solid ${alpha(meta.color, 0.32)}`,
      }}
    >
      <Box
        sx={{
          width: 7,
          height: 7,
          flexShrink: 0,
          borderRadius: "50%",
          backgroundColor: meta.color,
        }}
      />
      <Typography
        variant="caption"
        sx={{ fontWeight: 700, color: meta.textColor, lineHeight: 1.4 }}
      >
        {meta.label}
      </Typography>
    </Box>
  );
};

export default StatusPill;
